export const REQUEST_TO_GET_ALL_INVOICES = "REQUEST_TO_GET_ALL_INVOICES";
export const RECEIVE_ALL_INVOICES = "RECEIVE_ALL_INVOICES";
export const GETTING_ERROR_IN_GET_ALL_INVOICES = "GETTING_ERROR_IN_GET_ALL_INVOICES";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_PAYMENT_STATUS = "SET_PAYMENT_STATUS";
export const SET_APPROVAL_STATUS = "SET_APPROVAL_STATUS";
export const INVOICE_LIST_WITH_INITIAL_FILTERS = "INVOICE_LIST_WITH_INITIAL_FILTERS";
export const RESET_INVOICE_LIST = "RESET_INVOICE_LIST";
